const features = [
  {
    icon: 'ri-4k-line',
    title: '高清不缓冲',
    desc: '全站资源支持1080P及以上画质，多线路智能调度确保播放流畅稳定，无论手机还是电脑都能享受清晰观影体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '与各大平台同步更新最新剧集和电影，热门电视剧、综艺、动漫番剧随播随更，绝不错过任何精彩内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全免费观影',
    desc: '无需注册、无需付费、无需下载App，打开即看。严格筛选内容来源，为用户提供安全可靠的免费在线观看环境。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-2">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 mb-8 font-body">为什么选择豆花视频？三个理由就够了</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={item.title}
              className="relative rounded-2xl p-6 md:p-8 bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-default group"
            >
              <div className="absolute top-0 right-0 w-20 h-20 rounded-bl-3xl bg-gradient-to-bl from-primary-50/60 to-transparent"></div>
              <div className="relative">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className={`${item.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed font-body">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}